interface LogoProps {
  className?: string;
  src?: string;
}

export default function Logo({
  className = "",
  src = "https://public.readdy.ai/ai/img_res/9b2af78c-4879-44d2-9aa7-3496aad7bfe4.png",
}: LogoProps) {
  return (
    <img
      src={src}
      alt="namba"
      title="ナンバ ロゴ"
      className={`block w-auto select-none align-middle ${className}`}
    />
  );
}